<template src="./EstadoDocumentos.html"></template>

<script>
export default {
  data() {
    return {
      estadoDocumentos: null,
      search: "",
      variableSeleccionada: null,
      arrayVariablesTabla: [],
      cantidaElementosMostrar: 0,
      options: {
        chart: {
          type: "pie",
          events: {
            dataPointSelection: (event, chartContext, config) => {
              if (config.selectedDataPoints[0].length === 0) {
                // this.variableSeleccionada = null;
                // this.search = "";
                // this.arrayVariablesTabla = [];
                // this.estadoDocumentos = null;
              } else {
                this.variableSeleccionada = null;
                this.search = "";
                this.arrayVariablesTabla = [];
                switch (config.dataPointIndex) {
                  case 0:
                    this.estadoDocumentos = "diligenciados";
                    this.$emit("limpiar");
                    break;
                  case 1:
                    this.estadoDocumentos = "no_diligenciados";
                    this.$emit("limpiar");
                    break;
                  default:
                    break;
                }
              }
            }
          }
        },
        colors: ["#D493B0", "#F0AE7B"],
        fill: {
          type: "gradient",
          gradient: {
            shade: "light"
          }
        },
        labels: this.labels,
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: "28px",
                  fontFamily: "Nunito, sans-serif",
                  color: "#dfsda",
                  offsetY: -10
                },
                value: {
                  show: true,
                  fontSize: "18px",
                  fontFamily: "Nunito, sans-serif",
                  color: undefined,
                  offsetY: 16,
                  formatter: function(val) {
                    return val;
                  }
                },
                total: {
                  show: true,
                  label: "Total",
                  color: "#373d3fDF",
                  fontSize: "20px",
                  fontWeight: 600,
                  formatter: function(w) {
                    return w.globals.seriesTotals.reduce((a, b) => {
                      return a + b;
                    }, 0);
                  }
                }
              }
            }
          }
        },
        legend: {
          position: "bottom"
        }
      }
    };
  },
  props: {
    variablesDocumento: {
      type: Array,
      default: () => []
    },
    series: {
      type: Array,
      default: () => []
    },
    programa: {
      type: String,
      default: null
    },
    coleccion: {
      type: String,
      default: null
    },
    documentoSeleccionado: {
      type: String,
      default: null
    },
    estadosDelPrograma: {
      type: Array,
      default: () => []
    },
    fechaInicial: {
      type: Number,
      default: null
    },
    fechaFinal: {
      type: Number,
      default: null
    },
    labels: {
      type: Array,
      default: () => ["Diligenciados", "No diligenciados"]
    },
    width: {
      type: Number,
      default: 300
    },
    height: {
      type: Number,
      default: 350
    },
    banderaMostrarSidebar:{
      type: Boolean,
      default: false
    },
    enviarMensajeCerrado:{
      type: Boolean,
      default: true
    }
  },
  computed: {
    banderaFormularioAnalisis() {
      return this.estadoDocumentos && this.estadoDocumentos === "diligenciados";
    },
    banderaConsultar() {
      if (
        this.estadoDocumentos &&
        this.estadoDocumentos === "no_diligenciados"
      ) {
        return true;
      } else if (
        this.estadoDocumentos &&
        this.estadoDocumentos === "diligenciados"
      ) {
        if (
          this.variableSeleccionada !== null &&
          this.variableSeleccionada.length > 0
        ) {
          if (this.arrayVariablesTabla.length > 0) {
            if (!this.arrayVariablesTabla.includes(this.variableSeleccionada)) {
              return false;
            } else {
              return true;
            }
          }
        }
      }
      return false;
    }
  },
  methods: {
    calcularCantidadSeleccionada(arrayValores) {
      let maximaLongitud = 0;
      arrayValores.map(variable => {
        if (variable.length >= maximaLongitud) {
          maximaLongitud = variable.length;
          if (maximaLongitud >= 7) {
            this.cantidaElementosMostrar = 0;
          } else if (maximaLongitud >= 4 && maximaLongitud < 7) {
            this.cantidaElementosMostrar = 1;
          } else {
            this.cantidaElementosMostrar = 2;
          }
        }
      });
      return arrayValores;
    },
    consultarAnalisis() {
      this.$emit("consultarAnalisis", {
        variableSeleccionada: this.variableSeleccionada,
        arrayVariablesTabla: this.arrayVariablesTabla,
        estadoDocumentos: this.estadoDocumentos
      });
    }
  },
  watch: {
    variableSeleccionada(newValue, oldValue) {
      if (newValue) {
        this.arrayVariablesTabla = [newValue];
      }
    }
  }
};
</script>

<style lang="scss" src="./EstadoDocumentos.scss">
.estadoDocumentos {
  .autocomplete {
    margin-top: 12px;
    .v-input__control {
      .v-input__slot {
        background-color: #f3f3f3 !important;
        .v-select__slot {
          input {
            color: #2d2d2d !important;
            font-weight: 600;
          }
          .mdi-menu-down::before {
            color: #3a899a !important;
            height: 28px;
            font-size: 28px;
          }
        }
      }
    }
  }
  .autocomplete-llenado {
    .v-input__control {
      .v-input__slot {
        background-color: #d9edf0 !important;
        .v-select__slot {
          input {
            color: #575757 !important;
            font-weight: 600;
          }
          .mdi-menu-down::before {
            color: #575757 !important;
            height: 28px;
            font-size: 28px;
          }
        }
      }
    }
  }
  .autocomplete-deshabilitado {
    .v-input__control {
      .v-input__slot {
        background-color: #f3f3f3 !important;
        .v-select__slot {
          input {
            color: #2d2d2d !important;
          }
          .mdi-menu-down::before {
            color: #666666 !important;
            height: 28px;
            font-size: 28px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EstadoDocumentos/EstadoDocumentos.vue